import { FC, lazy } from 'react';

const WelcomePageDefaultView = lazy(() => import('./default-view/WelcomePageDefaultView'));

export const WelcomePage: FC = () => <WelcomePageDefaultView />;
